// PRs or funcational titles, e.g. {AD: "ADMIN/EXECUTIVE SUPPORT", ...}
// to [ { label: "ADMIN/EXECUTIVE SUPPORT", value: "AD", ... ]
export const transformToOptions = data => {
    const items = [];
    for (const [key, value] of Object.entries(data)) {
        items.push({ label: value, value: key });
    }
    return items;
};
